var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .solar-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .solar-1, .solar-2 {\n        stroke: #000;\n        stroke-linecap: round;\n      }\n\n      .solar-1, .solar-2, .solar-3 {\n        fill: none;\n      }\n\n      .solar-2 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "solar-2",
    points: "5 24.42 18.84 24.42 45 36.87 11.82 36.87 5 24.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-2",
    x1: 9.71,
    y1: 32.72,
    x2: 36.12,
    y2: 32.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-2",
    x1: 7.47,
    y1: 28.57,
    x2: 27.36,
    y2: 28.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-2",
    x1: 14.23,
    y1: 24.42,
    x2: 33.94,
    y2: 36.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-2",
    x1: 9.61,
    y1: 24.42,
    x2: 22.88,
    y2: 36.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "solar-1",
    d: "m44.57,17.73c-4.08,0-7.38-3.3-7.38-7.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-1",
    x1: 31.97,
    y1: 10.61,
    x2: 28.66,
    y2: 10.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-1",
    x1: 35.84,
    y1: 19.44,
    x2: 33.5,
    y2: 21.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "solar-1",
    x1: 44.82,
    y1: 22.95,
    x2: 44.82,
    y2: 26.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "solar-2",
    points: "45 39.65 10.7 39.65 5 28.98"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "solar-3",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolar);
export default __webpack_public_path__ + "static/media/icon-solar.675cbe88618757ecf6eaf592bfca5b35.svg";
export { ForwardRef as ReactComponent };